




















import { Component, Prop, Vue } from "vue-property-decorator";
import { countryCodes } from "@/config/user/citizenship";
import { VueSelect } from "vue-select";

@Component({ components: { "v-select": VueSelect } })
export default class Citizenship extends Vue {
  @Prop({ type: String, default: "" }) citizenship!: string;
  @Prop({ type: Boolean, default: true }) required!: boolean;
  countryCodes = countryCodes;
  select: Element | null = null;

  get citizenships(): Array<string> {
    const arr: Array<string> = [];
    this.countryCodes.forEach((c) => arr.push(c.subject));
    return arr;
  }
}
